import { ApiResponse } from "interface/response"
import { ILandingNote, LandingNoteHead,  } from "interface/landingNote"
import { AxiosApi } from "./index"
import { FilterOption } from "interface/index"
import { LandingNoteLine } from "interface/landingNote"
import { Comment } from "component/pages/landingNote/utils"
import { useInfoStore } from "store/error";

export interface LandingNoteFilter extends  FilterOption{
    noteNumber?:  number | null,
    vesselName?: string
    vesselId?: string
      terminal?: string,
      terminalCode?: string,
      statusId?: string
      status?: string
      speciesCode?: string | null,
      speciesName?: string

}

export interface LandingNoteLineFilter{
    noteNumber?:  number,
    source? : number, 
    specieCode?: string
}

export  async function getLandingNotesApi(filter : LandingNoteFilter ) {
    const apiUri = "LandingNote/GetList"
   try {
      const landingNote = await AxiosApi.get<ApiResponse<ILandingNote[]>>(apiUri, {params:{
         ...filter,
      }})

      return landingNote.data
   } catch (error: any) {
      const { setError } = useInfoStore.getState();
      setError(error);
      throw  error
   }
}
    
export  async function getLandingNoteLinesApi(filter :LandingNoteLineFilter ) {
    const apiUri = "LandingNote/GetLines"
   try {
      const landingNoteLines = await AxiosApi.get<ApiResponse<LandingNoteLine[]>>(apiUri, {params:{
         ...filter,
      }})
      return landingNoteLines.data
   } catch (error: any) {
      const { setError } = useInfoStore.getState();
      setError(error);
      throw  error
   }
}
    
export  async function getLandingNoteVHeadApi(noteNumber :number ) {
    const apiUri = "LandingNote/GetNoteHead"
   try {
      const landingNoteHead = await AxiosApi.get<ApiResponse<LandingNoteHead>>(apiUri, {params:{
         noteNumber 
      }})
      return landingNoteHead.data
   } catch (error: any) {
      const { setError } = useInfoStore.getState();
      setError(error);
      throw  error
   }
}
    
export  async function saveLandingNoteHead(saleNoteHead: LandingNoteHead ) {
   const apiUri = "LandingNote/SaveNoteHead"
     
   try {
     const salesNote = await AxiosApi.post<ApiResponse<LandingNoteHead>>(apiUri, saleNoteHead)
     return salesNote.data
  } catch (error: any) {
     const { setError } = useInfoStore.getState();
     setError(error);
     throw  error
  }
}

export async function setNoteHeadStepApi(id: number | null, step: number) {
    const apiUri = "landingnote/setstep";

    try {
        const registrationLine = await AxiosApi.get(apiUri, { params: { id, step } })
        return registrationLine.data
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error;
    }
}


export async function importLandingNote(file: File, noteNumber: number) {
    const apiUri = "LandingNote/ImportLandingNote"

    try {
        const formData = new FormData();
        formData.append('file', file);

        const landingNote = await AxiosApi.post<ApiResponse<LandingNoteHead>>(apiUri, formData, {
            params: { noteNumber },
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })

        return landingNote.data
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error
    }
}

export async function getLandingNoteLineViewApi(noteNumber: number) {
    const apiUri = "LandingNote/GetLineView"
    try {

        const salesNote = await AxiosApi.get<ApiResponse<LandingNoteLine[]>>(apiUri, {
            params: {
                noteNumber,
            }
        })
        return salesNote.data
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error
    }
}


export  async function getSalesNoteHeadCommentsApi(noteHeaderId :number ) {
   const apiUri = "SalesNote/GetNoteHeadComments"
     
   try {
     const salesNote = await AxiosApi.get<ApiResponse<Comment[]>>(apiUri, {params:{
       noteHeaderId,
     }})
     return salesNote.data
  } catch (error: any) {
     const { setError } = useInfoStore.getState();
     setError(error);
     throw  error
  }
}

export  async function saveNoteHeadComment({noteHeaderId,id, description}:{noteHeaderId :number,id: number, description: string} ) {
   const apiUri = "Landing/SaveNoteHeadComment"
     
   try {
     const salesNote = await AxiosApi.get<ApiResponse<LandingNoteLine[]>>(apiUri, {params:{
       noteHeaderId,id, description
     }})
     return salesNote.data
  } catch (error: any) {
     const { setError } = useInfoStore.getState();
     setError(error);
     throw  error
  }
}

export  async function deleteNoteHeadComment(id: number ) {
   const apiUri = "LandingNote/DeleteNoteHeadComment"
     
   try {
     const salesNote = await AxiosApi.delete<ApiResponse<any>>(apiUri, {params:{
       id
     }})
     return salesNote.data
  } catch (error: any) {
     const { setError } = useInfoStore.getState();
     setError(error);
     throw  error
  }
}


export  async function getLandingNoteHeadCommentsApi(noteHeaderId :number ) {
   const apiUri = "LandingNote/GetNoteHeadComments"
     
   try {
     const salesNote = await AxiosApi.get<ApiResponse<Comment[]>>(apiUri, {params:{
       noteHeaderId,
     }})
     return salesNote.data
  } catch (error: any) {
     const { setError } = useInfoStore.getState();
     setError(error);
     throw  error
  }
}

export  async function saveNoteHeadComments({noteHeaderId,id, description}:{noteHeaderId :number,id: number, description: string} ) {
   const apiUri = "LandingNote/SaveNoteHeadComment"
     
   try {
     const salesNote = await AxiosApi.get<ApiResponse<LandingNoteLine[]>>(apiUri, {params:{
       noteHeaderId,id, description
     }})
     return salesNote.data
  } catch (error: any) {
     const { setError } = useInfoStore.getState();
     setError(error);
     throw  error
  }
}

export async function saveLandingNoteLine(saleNoteHeadLine: LandingNoteLine) {
    const apiUri = "LandingNote/SaveNoteLine"

    try {
        const salesNote = await AxiosApi.post<ApiResponse<LandingNoteLine>>(apiUri, saleNoteHeadLine)
        return salesNote.data
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error
    }
}

export  async function deleteLandingNoteLine(id: number ) {
   const apiUri = "LandingNote/DeleteNoteLine"
     
   try {
     const salesNote = await AxiosApi.delete<ApiResponse<LandingNoteLine>>(apiUri, {params:{
       id
     }})
     return salesNote.data
  } catch (error: any) {
     const { setError } = useInfoStore.getState();
     setError(error);
     throw  error
  }
}

export  async function SaveLandingNoteLineComment({description, noteLineId, id = 0}:{description: string, noteLineId: number, id: number } ) {
   const apiUri = "LandingNote/SaveNoteLineComment"
     
   try {
     const salesNote = await AxiosApi.get<ApiResponse<LandingNoteLine>>(apiUri, { params:{
       description, noteLineId, id
     }},)
     return salesNote.data
  } catch (error: any) {
     const { setError } = useInfoStore.getState();
     setError(error);
     throw  error
  }
}

export  async function getLandingNoteLineComments(noteLineId: number ) {
   const apiUri = "LandingNote/GetNoteLineComments"
      
   try {
     const salesNote = await AxiosApi.get<ApiResponse<Comment[]>>(apiUri, {params:{
       noteLineId
     }})
     return salesNote.data
  } catch (error: any) {
     const { setError } = useInfoStore.getState();
     setError(error);
     throw  error
  }
}

export  async function deleteLandingNoteLineComment(id: number ) {
   const apiUri = "LandingNote/DeleteNoteLineComment"
     
   try {
     const salesNote = await AxiosApi.delete<ApiResponse<any>>(apiUri, {params:{
       id
     }})
     return salesNote.data
  } catch (error: any) {
     const { setError } = useInfoStore.getState();
     setError(error);
     throw  error
  }
}

export  async function getLandingNoteStatus( ) {
   const apiUri = "LandingNote/Status"
     
   try {
     const salesNote = await AxiosApi.get<ApiResponse<{id: number|null, statusText: string| null}[]>>(apiUri)
     return salesNote.data.data
  } catch (error: any) {
     const { setError } = useInfoStore.getState();
     setError(error);
     throw  error
  }
}

export async function completeLandingNoteApi(id: number) {
    const apiUri = "LandingNote/CompleteLandingNote";
    try {
        const salesNote = await AxiosApi.get<ApiResponse<string>>(apiUri, { params: { id } });
        return salesNote.data;
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error;
    }
}

export async function landingNoteProductConditionFilter() {
    const apiUri = "LandingNote/ProductConditionFilter";
    try {
        const salesNote = await AxiosApi.get<ApiResponse<{ value: boolean, name: string , displayName: string }[]>>(apiUri);
        return salesNote.data.data;
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error;
    }
    
}

export async function newLandingNoteApi(id: number) {
    const apiUri = "LandingNote/NewNote";
    try {
        const landingNote = await AxiosApi.get<ApiResponse<boolean>>(apiUri, { params: { id } });
        return landingNote.data;
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error;
    }
}

export async function updateLandingNoteProductConditionFilter(params: {
    fresh: boolean;
    frozen: boolean;
    filet: boolean;
    user: boolean;
}) {
    const apiUri = "LandingNote/UpdateProductConditionFilter";
    try {
        const response = await AxiosApi.get<ApiResponse<boolean>>(apiUri, { params });
        return response.data;
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error;
    }
}

export async function deleteLandingNoteApi(noteNumber: number) {
    const apiUri = "LandingNote/DeleteNote";
    try {
        const response = await AxiosApi.delete<ApiResponse<any>>(apiUri, { params: { noteNumber } });
        return response.data;
    } catch (error: any) {
        const { setError } = useInfoStore.getState();
        setError(error);
        throw error;
    }
}